import authService from "./authService";

export default {
    service: new authService()
}